import { cva } from 'class-variance-authority'

export const rootStyles = cva(
  `
    grid
    gap-2
  `
)

export const itemStyles = cva(
  `
    aspect-square
    h-4
    w-4
    rounded-full
    border
    border-primary
    text-neutral-700
    ring-offset-background
    focus:outline-none
    focus-visible:ring-2
    focus-visible:ring-ring
    focus-visible:ring-offset-2
    disabled:cursor-not-allowed
    disabled:opacity-50
    hover:cursor-pointer
  `
)

export const itemLabelStyles = cva(
  `
    ml-2
    text-sm
    disabled:text-neutral-400
  `,
  {
    variants: {
      disabled: {
        true: 'text-neutral-400',
        false: 'text-neutral-700',
      },
    },
    defaultVariants: {
      disabled: false,
    },
  }
)

export const indicatorStyles = cva(
  `
    flex
    items-center
    justify-center
  `
)

export const iconStyles = cva(
  `
    h-3
    w-3
    fill-neutral-700
    text-neutral-700
    mt-[-1px]
  `
)

export const itemContainerStyles = cva(
  `
    flex
    items-center
    space-x-2
    my-1
  `
)
